import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';

// render - dashboard
const CommandCenter = Loadable(lazy(() => import('pages/kems/CommandCenter')));
const VoterIntelligence = Loadable(lazy(() => import('pages/kems/VoterIntelligence')));
const VoterRegister = Loadable(lazy(() => import('pages/kems/VoterRegister')));
const TeamManagement = Loadable(lazy(() => import('pages/kems/TeamManagement')));
const Reports = Loadable(lazy(() => import('pages/kems/Reports')));
const Manifesto = Loadable(lazy(() => import('pages/kems/Manifesto')));
const MheshAssistant = Loadable(lazy(() => import('pages/kems/MheshAssistant')));
const NewsIntelligence = Loadable(lazy(() => import('pages/kems/NewsIntelligence')));
const AgentActivity = Loadable(lazy(() => import('pages/kems/AgentActivity')));
const Broadcasts = Loadable(lazy(() => import('pages/kems/Broadcasts')));
const Notifications = Loadable(lazy(() => import('pages/kems/Notifications')));
const CallsWardDatabase = Loadable(lazy(() => import('pages/kems/CallsWardDatabase')));
const CommunicationWorkflow = Loadable(lazy(() => import('pages/kems/CommunicationWorkflow')));
const CommunicationRegistry = Loadable(lazy(() => import('pages/kems/CommunicationRegistry')));
const CommunicationReports = Loadable(lazy(() => import('pages/kems/CommunicationReports')));
const WhatsAppNumbers = Loadable(lazy(() => import('pages/kems/WhatsAppNumbers')));
const AgentNetwork = Loadable(lazy(() => import('pages/kems/AgentNetwork')));
const AgentTask = Loadable(lazy(() => import('pages/kems/AgentTask')));
const AgentNotifications = Loadable(lazy(() => import('pages/kems/AgentNotifications')));
const PollsSurveys = Loadable(lazy(() => import('pages/kems/PollsSurveys')));
const PollResults = Loadable(lazy(() => import('pages/kems/PollResults')));
const TallyResults = Loadable(lazy(() => import('pages/kems/TallyResults')));
const OperationsPlaceholder = Loadable(lazy(() => import('pages/kems/OperationsPlaceholder')));
const OperationsModule = Loadable(lazy(() => import('pages/kems/OperationsModule')));
const WalletPage = Loadable(lazy(() => import('pages/kems/WalletPage')));
const AgentTipsPage = Loadable(lazy(() => import('pages/kems/AgentTipsPage')));
const AgentTipsPreviewPage = Loadable(lazy(() => import('pages/kems/AgentTipsPreviewPage')));
const AgentTipsStatusPage = Loadable(lazy(() => import('pages/kems/AgentTipsStatusPage')));
const WalletTopUp = Loadable(lazy(() => import('pages/kems/WalletTopUp')));
const WalletTopUpMethod = Loadable(lazy(() => import('pages/kems/WalletTopUpMethod')));
const WalletTopUpStatus = Loadable(lazy(() => import('pages/kems/WalletTopUpStatus')));
const Settings = Loadable(lazy(() => import('pages/settings')));
const LogOut = Loadable(lazy(() => import('pages/settings/logout')));
const ContactsPage = Loadable(lazy(() => import('pages/kems/ContactsPage')));
const CommsCompose = Loadable(lazy(() => import('pages/kems/CommsCompose')));
const CommsDashboard = Loadable(lazy(() => import('pages/kems/CommsDashboard')));
const Activities     = Loadable(lazy(() => import('pages/kems/Activities')));
const BudgetUtilization = Loadable(lazy(() => import('pages/kems/BudgetUtilization')));
const ReportedIncidents = Loadable(lazy(() => import('pages/kems/ReportedIncidents')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      index: true,
      element: <CommandCenter />
    },
    {
      path: 'command-center',
      element: <CommandCenter />
    },
    {
      path: 'activities',
      element: <Activities />
    },
    {
      path: 'voter-intelligence',
      element: <VoterIntelligence />
    },
    {
      path: 'voter-register',
      element: <VoterRegister />
    },
    {
      path: 'account/team',
      element: <TeamManagement />
    },
    {
      path: 'reports',
      element: <Reports />
    },
    {
      path: 'manifesto',
      element: <Manifesto />
    },
    {
      path: 'mhesh-ai-assistant',
      element: <MheshAssistant />
    },
    {
      path: 'news-intelligence',
      element: <NewsIntelligence />
    },
    {
      path: 'agent-activity',
      element: <AgentActivity />
    },
    {
      path: 'notifications',
      element: <Notifications />
    },
    {
      path: 'polls-surveys',
      element: <PollsSurveys />
    },
    {
      path: 'elections',
      children: [
        {
          path: 'create-polls',
          element: <PollsSurveys />
        },
        {
          path: 'poll-results',
          element: <PollResults />
        },
        {
          path: 'tally-results',
          element: <TallyResults />
        },
        {
          path: 'reported-incidents',
          element: <ReportedIncidents />
        }
      ]
    },
    {
      path: 'communications',
      children: [
        {
          path: 'overview',
          element: <CommsDashboard />
        },
        {
          path: 'compose',
          element: <CommsCompose />
        },
        {
          path: 'email-campaigns',
          element: <Broadcasts />
        },
        {
          path: 'contacts',
          element: <ContactsPage />
        },
        {
          path: 'whatsapp',
          children: [
            {
              path: 'from-file',
              element: <CommunicationWorkflow workflowKey="whatsapp-from-file" />
            },
            {
              path: 'ward-database',
              element: <CommunicationWorkflow workflowKey="whatsapp-ward-database" />
            },
            {
              path: 'team-database',
              element: <CommunicationWorkflow workflowKey="whatsapp-team-database" />
            },
            {
              path: 'numbers',
              element: <WhatsAppNumbers />
            }
          ]
        }
      ]
    },
    {
      path: 'calls',
      children: [
        {
          path: 'from-file',
          element: <CommunicationWorkflow workflowKey="calls-from-file" />
        },
        {
          path: 'ward-database',
          element: <CallsWardDatabase />
        },
        {
          path: 'team-database',
          element: <CommunicationWorkflow workflowKey="calls-team-database" />
        },
        {
          path: 'reports',
          element: <CommunicationReports reportKey="calls" />
        }
      ]
    },
    {
      path: 'sms',
      children: [
        {
          path: 'from-file',
          element: <CommunicationWorkflow workflowKey="sms-from-file" />
        },
        {
          path: 'ward-database',
          element: <CommunicationWorkflow workflowKey="sms-ward-database" />
        },
        {
          path: 'team-database',
          element: <CommunicationWorkflow workflowKey="sms-team-database" />
        },
        {
          path: 'sender-ids',
          element: <CommunicationRegistry registryKey="sms-sender-ids" />
        },
        {
          path: 'reports',
          element: <CommunicationReports reportKey="sms" />
        }
      ]
    },
    {
      path: 'ground-operations',
      children: [
        {
          path: 'agent-network',
          element: <AgentNetwork />
        },
        {
          path: 'agent-task',
          element: <AgentTask />
        },
        {
          path: 'agent-notifications',
          element: <AgentNotifications />
        },
        {
          path: 'field-reports',
          element: <OperationsModule moduleKey="field-reports" />
        }
      ]
    },
    {
      path: 'finance',
      children: [
        {
          path: 'wallet',
          element: <WalletPage />
        },
        {
          path: 'wallet/tips',
          element: <AgentTipsPage />
        },
        {
          path: 'wallet/tips/preview',
          element: <AgentTipsPreviewPage />
        },
        {
          path: 'wallet/tips/success',
          element: <AgentTipsStatusPage />
        },
        {
          path: 'wallet/top-up',
          element: <WalletTopUp />
        },
        {
          path: 'wallet/top-up/mpesa',
          element: <WalletTopUpMethod methodKey="mpesa" />
        },
        {
          path: 'wallet/top-up/mpesa/processing',
          element: <WalletTopUpStatus methodKey="mpesa" statusKey="processing" />
        },
        {
          path: 'wallet/top-up/mpesa/success',
          element: <WalletTopUpStatus methodKey="mpesa" statusKey="success" />
        },
        {
          path: 'wallet/top-up/mpesa/failed',
          element: <WalletTopUpStatus methodKey="mpesa" statusKey="failed" />
        },
        {
          path: 'wallet/top-up/bank',
          element: <WalletTopUpMethod methodKey="bank" />
        },
        {
          path: 'wallet/top-up/bank/processing',
          element: <WalletTopUpStatus methodKey="bank" statusKey="processing" />
        },
        {
          path: 'wallet/top-up/bank/success',
          element: <WalletTopUpStatus methodKey="bank" statusKey="success" />
        },
        {
          path: 'wallet/top-up/bank/failed',
          element: <WalletTopUpStatus methodKey="bank" statusKey="failed" />
        },
        {
          path: 'wallet/top-up/visa',
          element: <WalletTopUpMethod methodKey="visa" />
        },
        {
          path: 'wallet/top-up/visa/processing',
          element: <WalletTopUpStatus methodKey="visa" statusKey="processing" />
        },
        {
          path: 'wallet/top-up/visa/success',
          element: <WalletTopUpStatus methodKey="visa" statusKey="success" />
        },
        {
          path: 'wallet/top-up/visa/failed',
          element: <WalletTopUpStatus methodKey="visa" statusKey="failed" />
        },
        {
          path: 'airtime',
          element: <OperationsModule moduleKey="airtime" />
        },
        {
          path: 'b2c-mpesa',
          element: <OperationsModule moduleKey="b2c-mpesa" />
        },
        {
          path: 'budget-utilization',
          element: <BudgetUtilization />
        },
        {
          path: 'payment-reports',
          element: <OperationsModule moduleKey="payment-reports" />
        },
        {
          path: 'payments-legacy',
          element: <OperationsModule moduleKey="payments-legacy" />
        }
      ]
    },
    {
      path: 'account',
      children: [
        {
          path: 'settings',
          element: <Settings />
        },
        {
          path: 'logout',
          element: <LogOut />
        }
      ]
    }
  ]
};

export default MainRoutes;
